import React, { useState } from 'react';
import { Button, Tabs, Tag } from 'antd';
import { ArrowUpOutlined, ThunderboltOutlined, BulbOutlined, } from '@ant-design/icons';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, } from 'recharts';
import { Link } from 'react-router-dom';
import DawnloadIcon from "../../assets/images/download-icon.svg"



const todaysDate = new Date().toISOString().split('T')[0];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <span>{payload[0].value}</span>
      </div>
    );
  }
  return null;
};

const GraphicalInsights = ({ interestOverTime = [] }) => {

  const data = Array.isArray(interestOverTime) && interestOverTime.length > 0
    ? [...interestOverTime]
        .sort((a, b) => new Date(a.week) - new Date(b.week)) // sort ascending
        .map(item => ({
          week: item.week,
          value: Number(item.interest) || 0
        }))
    : [];

  const hasData = data.length > 0;

  // Placeholder axis data for the empty state: the last 12 weekly dates at 0 so
  // the graph still renders a proper X axis, baseline and footer (flat line, no
  // real data) instead of a blank/mismatched panel.
  const emptyPlaceholder = (() => {
    const arr = [];
    const base = new Date();
    for (let i = 11; i >= 0; i--) {
      const dt = new Date(base);
      dt.setDate(base.getDate() - i * 7);
      arr.push({ week: dt.toISOString().split('T')[0], value: 0 });
    }
    return arr;
  })();

  const chartData = hasData ? data : emptyPlaceholder;

  // Calculate percentage change between last and first value
  let growthPercent = null;
  if (chartData.length > 1) {
    const first = chartData[0].value;
    const last = chartData[chartData.length - 1].value;
    if (first !== 0) {
      growthPercent = (((last - first) / Math.abs(first)) * 100).toFixed(1);
    } else if (last !== 0) {
      growthPercent = '∞';
    } else {
      growthPercent = '0.0';
    }
  }

  return (
    <div className="graphical-insights-container">
      <div className="chart-area">
        <div className="graphical-chart-headding">
          <h6>INTEREST OVER TIME</h6>
          {/* <div className="score-box">
          <h6 className="score-label">Overall Score</h6>
          <div className="score-value">
            <span className="score-number">85</span>/100
          </div>
          <Tag className="status-tag">Excellent</Tag>
        </div> */}
        </div>
        <div className='interest-main-section'>
          <div className="chart-card">
            <ResponsiveContainer width="100%" height={250}>
              <AreaChart data={chartData}>
                <defs>
                  <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#1e3a8a" stopOpacity={0.6} />
                    <stop offset="95%" stopColor="#1e3a8a" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <XAxis dataKey="week" />
                <YAxis />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey="value"
                  stroke="#1e3a8a"
                  fillOpacity={1}
                  fill="url(#colorValue)"
                />
              </AreaChart>
            </ResponsiveContainer>

            <div className="chart-footer">
              <div className="chart-left-outer">
                <span className="highlight-tag mx-3">All Time High</span>
              </div>
              <div className="percentage-box">
                <ArrowUpOutlined style={{ color: "#00b96b" }} />
                <span className="growth-text">
                  {growthPercent !== null ? `${growthPercent}%` : '--'}
                </span>
                <span className="month-text">{todaysDate}</span>
              </div>
            </div>
          </div>

          {/* <div className="score-area">
          <div className="link-box">
          <div className="link-metric">
              <div className="metric-name">LINK ANALYSIS</div>
              <Link
                  className="link-url"
                  href="https://vogue.com/sustainable-fashion"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                  https://vogue.com/sustainable-fashion
              </Link>
          </div>
          <div className="link-metric">
              <div className="metric-name">CREDIBILITY</div>
              <div className="metric-value">
                  92% <span className="negative">↓ 2.8%</span>{" "}
             <div className='metric-right-icon'><BulbOutlined /></div> 
              </div>
          </div>

          <div className="link-metric">
              <div className="metric-name">POPULARITY</div>
              <div className="metric-value">
              85% <span className="positive">↑ 8%</span>{" "}
              <div className='metric-right-icon'><ThunderboltOutlined /></div>
              </div>
          </div>

          <div className="link-metric">
              <div className="metric-name">POPULARITY</div>
              <div className="metric-value">
              85% <span className="positive">↑ 8%</span>{" "}
              <div className='metric-right-icon'><ThunderboltOutlined /></div>
              </div>
          </div>
          </div>
      </div> */}
        </div>


      </div>


    </div>
  )
};

export default GraphicalInsights;
